export default __webpack_public_path__ + "static/media/uni-shuttle.19586bcf.jpg";